import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getTerritories = createAsyncThunk(
  "territory/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.TERRITORY.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getTerritories.
export const getTerritoriesLookup = createAsyncThunk(
  "territory/getLookup",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.TERRITORY.LOOKUP}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTerritory = createAsyncThunk(
  "territory/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.TERRITORY.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editTerritory = createAsyncThunk(
  "territory/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.TERRITORY.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteTerritory = createAsyncThunk(
  "territory/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.TERRITORY.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const territorySlice = createSlice({
  name: "territory",
  initialState: {
    territory_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTerritories.fulfilled, (state, action) => {
      state.territory_list = action.payload.data.list;
    });
    builder.addCase(getTerritoriesLookup.fulfilled, (state, action) => {
      state.territory_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } = territorySlice.actions;
export default territorySlice.reducer;
